<fieldset>
  <legend>Echantillonnage*</legend>
  <div class="flex flex-wrap gap-3 state-container">
    <mat-radio-group [formControl]="valueFormControl">
      @for (item of stationSamplings; track item) {
        <mat-radio-button
          [value]="item.value"
          [color]="'primary'">{{ item.label }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</fieldset>
